import { render, staticRenderFns } from "./sesionLive.view.vue?vue&type=template&id=5152e811&"
import script from "./sesionLive.view.vue?vue&type=script&lang=js&"
export * from "./sesionLive.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports